export class DowntimeEditStatus {
  public constructor(init: Partial<DowntimeEditStatus>) {
    Object.assign(this, init)
    if (!init.month || !init.dateLastModified) {
      throw new Error("Trying to create a new downtime edit static with no dates")
    }

    this.month = new Date(init.month)
    this.dateLastModified = new Date(init.dateLastModified)
  }

  siteKey: string = ""
  month: Date = new Date()
  status: string = ""
  lastModifiedBy: string = ""
  dateLastModified: Date = new Date()
}
